import Images from './images';

export default {
  section1: [
    {
      imgSrc: Images.home,
      activeImgSrc: Images.homeActive,
      url: '/',
      title: 'Home'
    },
    {
      imgSrc: Images.favourites,
      activeImgSrc: Images.favourites,
      url: '/viewall/favourites',
      title: 'Favourites'
    },
    {
      imgSrc: Images.history,
      activeImgSrc: Images.historyActive,
      url: '/viewall/history',
      title: 'History'
    }
  ],
  section2: [
    {
      imgSrc: Images.new,
      activeImgSrc: Images.new,
      url: '/viewall/newgames',
      title: 'New Games'
    },
    {
      imgSrc: Images.puzzles,
      activeImgSrc: Images.puzzlesActive,
      url: '/viewall/puzzles',
      title: 'Puzzles'
    },
    {
      imgSrc: Images.quiz,
      activeImgSrc: Images.quizActive,
      url: '/viewall/quiz',
      title: 'Quiz'
    },
    {
      imgSrc: Images.racing,
      activeImgSrc: Images.racingActive,
      url: '/viewall/racing',
      title: 'Racing'
    },
    {
      imgSrc: Images.arcade,
      activeImgSrc: Images.arcadeActive,
      url: '/viewall/arcade',
      title: 'Arcade'
    },
    {
      imgSrc: Images.sports,
      activeImgSrc: Images.sportsActive,
      url: '/viewall/sports',
      title: 'Sports'
    },
    {
      imgSrc: Images.strategy,
      activeImgSrc: Images.strategyActive,
      url: '/viewall/strategy',
      title: 'Strategy'
    }
  ]
} as any;
